import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AddHallPassReasonRequest } from "../../services/AddHallPassReasonRequest";
import { ScanPointService } from "../../services/scanpoint.service";

@Component({
	selector: "app-add-hall-pass-reason",
	templateUrl: "./add-hall-pass-reason.component.html",
	styleUrls: ["./add-hall-pass-reason.component.css"],
})
export class AddHallPassReasonComponent implements OnInit {
	constructor(public ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig, private scanPointService: ScanPointService) {}

	ngOnInit(): void {
		//Get data from parent
		this.user = this.dialogConfig.data.User;
		this.SelectedFacilityID = this.dialogConfig.data.FacilityID;

		this.UserType = this.user.UserLevelID == 1 ? "District User" : "School User";
	}

	/////////////////////////
	// Data
	/////////////////////////
	user: any;
	UserType: any;
	SelectedFacilityID: any = 0;

	//Form data
	PassReasonCode: string = "";
	PassReasonDesc: string = "";
	DefaultPassDur: number = 0;
	IsQuickPass: boolean = true;
	IsGroupAssign: boolean = true;
	IsAssignFromClass: boolean = true;
	IsDistrictLevel: boolean = false;
	UseClassAttnExcu: boolean = false;

	//Security

	/////////////////////////

	/////////////////////////
	// Buttons
	/////////////////////////
	onUpdate() {
		let parms: AddHallPassReasonRequest = {
			ApplicationItemID: "",
			PassReasonCode: this.PassReasonCode,
			PassReasonDesc: this.PassReasonDesc,
			DefaultPassDur: this.DefaultPassDur,
			IsQuickPass: this.BoolToInt(this.IsQuickPass),
			IsGroupAssign: this.BoolToInt(this.IsGroupAssign),
			IsAssignFromClass: this.BoolToInt(this.IsAssignFromClass),
			IsDistrictLevel: this.BoolToInt(this.IsDistrictLevel),
			UseClassAttnExcu: this.BoolToInt(this.UseClassAttnExcu),
			DefinedBy: this.user.UserLevelID,
			FacilityID: this.SelectedFacilityID,
		};

		var result = this.scanPointService.AddHallPassReason(parms);
		result.subscribe(
			(response) => {
				this.ref.close(1);
			},
			(error) => {}
		);
	}
	onCancel() {
		this.ref.close(0);
	}
	/////////////////////////

	/////////////////////////
	// Helpers
	/////////////////////////
	GetTypeColor(val) {
		if (val == "District User") {
			return "#00bb19";
		} else if (val == "School User") {
			return "#a80000";
		} else {
			return "#0000FF";
		}
	}

	BoolToInt(val) {
		return val ? 1 : 0;
	}
	/////////////////////////
}
